module.exports = __webpack_public_path__ + "img/3.b5af8f87.jpg";